import { useTranslation } from "react-i18next";
import { FaStar } from "react-icons/fa";
import Slider from "react-slick";
import { useRef, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./TestimonialsStyle.css";
import test1 from "../../assets/img1.PNG";
import test2 from "../../assets/img2.PNG";
import test3 from "../../assets/img3.PNG";
import test4 from "../../assets/img4.PNG";
import test5 from "../../assets/img5.PNG";
import test6 from "../../assets/img6.PNG";
import test8 from "../../assets/img8.PNG";
import test9 from "../../assets/img9.PNG";
import test10 from "../../assets/img10.PNG";

const Testimonials = ({ id }) => {
  const { t } = useTranslation();
  const sliderRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    swipe: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const testimonials = [
    test1,
    test2,
    test3,
    test4,
    test5,
    test6,
    test8,
    test9,
    test10,
  ];

  const goToPrev = () => {
    sliderRef.current.slickPrev();
  };

  const goToNext = () => {
    sliderRef.current.slickNext();
  };

  const openPopup = (img) => {
    setSelectedImage(img);
  };

  const closePopup = () => {
    setSelectedImage(null);
  };

  return (
    <section className="results-section" id={id}>
      <h2 className="results-title">{t("testimonials.title")}</h2>
      <div className="results-content container">
        <div className="results-text">
          <p className="result-item">
            <FaStar className="star-icon" />
            <FaStar className="star-icon" />
            <FaStar className="star-icon" />
            <FaStar className="star-icon" />
            {t("testimonials.googleRating")}
          </p>
          <p className="result-item">{t("testimonials.roi")}</p>
          <p className="result-item MDC">
            {t("testimonials.usedBy")}
            <span>
              {" "}
              <span>{t("testimonials.medical")}</span>{" "}
              <span>{t("testimonials.dental")}</span>{" "}
              <span>{t("testimonials.cosmetic")}</span>
            </span>
          </p>
          <p className="result-item">{t("testimonials.patientsReached")}</p>
          <div className="slider-arrows">
            <button className="custom-prev" onClick={goToPrev}>
              ←
            </button>
            <button className="custom-next" onClick={goToNext}>
              →
            </button>
          </div>
        </div>
        <div className="results-slider">
          <Slider {...settings} ref={sliderRef}>
            {testimonials.map((img, index) => (
              <div key={index} className="testimonial-slide">
                <img
                  src={img}
                  alt={`Testimonial ${index + 1}`}
                  className="testimonial-image"
                  onClick={() => openPopup(img)}
                  loading="lazy"
                  aria-label={`View enlarged testimonial ${index + 1}`}
                  onError={(e) => {
                    console.error(`Failed to load image: ${img}`);
                    e.target.src =
                      "https://via.placeholder.com/300x200?text=Image+Not+Found";
                  }}
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
      {selectedImage && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="popup-close" onClick={closePopup}>
              &times;
            </button>
            <img
              src={selectedImage}
              alt="Enlarged testimonial"
              className="popup-image"
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default Testimonials;
